import type { TranslationFunctions } from '$i18n/i18n-types';
import type ERAR from '$lib/erar/spec';
import { QueueType } from '../queue';

export function getCurrentSeasonId(seasons: ERAR.Schema.StaticSeasonList) {
  const now = Date.now();
  let currentSeason: number | undefined;

  for (let i = seasons.length - 1; i >= 0; i--) {
    if (seasons[i].startedAt < now) {
      currentSeason = seasons[i].id;
      break;
    }
  }

  return currentSeason ?? seasons[seasons.length - 1].id;
}

export function getSeasonName(LL: TranslationFunctions, seasonId: number) {
  if (isNormal(seasonId)) {
    return LL.players.seasonTab.normal();
  }

  if (isAfter1_0(seasonId)) {
    const displaySeasonNumber = Math.ceil((seasonId - 19 + 1) / 2);
    if (seasonId % 2 === 0) {
      return LL.players.seasonTab.rankPreseason({ seasonNumber: displaySeasonNumber });
    } else {
      return LL.players.seasonTab.rankSeason({ seasonNumber: displaySeasonNumber });
    }
  } else {
    const displaySeasonNumber = Math.ceil((seasonId + 1) / 2);
    if (seasonId % 2 === 0) {
      return LL.players.seasonTab.rankPreseasonBefore1_0({ seasonNumber: displaySeasonNumber });
    } else {
      return LL.players.seasonTab.rankSeasonBefore1_0({ seasonNumber: displaySeasonNumber });
    }
  }
}

export function isNormal(seasonId: number | undefined) {
  return (seasonId ?? 0) === 0;
}

export function isAfter1_0(seasonId: number) {
  return seasonId >= 19;
}

export function isAfter1_0ByVersion(gameVersion: string) {
  return parseInt(gameVersion.split('.')[0]) >= 1;
}

export function getMaxTeamCount(seasonId: number, queueType: QueueType): number {
  if (isAfter1_0(seasonId) && queueType === QueueType.Squad) {
    return 8;
  }

  switch (queueType) {
    case QueueType.Solo:
      return 18;
    case QueueType.Duo:
      return 9;
    case QueueType.Squad:
      return 6;
    case QueueType.Cobalt:
      return 2;
    case QueueType.Union:
      return 4;
  }
}
